// src/layouts/AdminLayout.jsx
import React from 'react'
import { Outlet } from 'react-router-dom'
import AdminHeader from '../components/layout/AdminHeader.jsx'
import AdminSidebar from '../components/layout/AdminSidebar.jsx'
import './AdminLayout.scss'

export default function AdminLayout() {
    return (
        <div className="admin-layout">
            <div className="admin-sidebar-wrapper">
                <AdminSidebar />
            </div>
            <div className="admin-main-wrapper">
                <AdminHeader />
                <main className="admin-content">
                    <Outlet />
                </main>
            </div>
        </div>
    )
}